import moment from 'moment';
import { useNavigate } from 'react-router';
import { JobListingCard } from '@tempmee/react-blocks';
import { useJobProfessionDisplay } from '~/hooks';
import { ProfessionTypeEnum } from '~/models';

import { IDraftJobCardProps } from './Types';

export const DraftJobCard = ({
  id,
  lastSavedAt,
  office,
  officeSelected,
  professionType,
  subProfession,
  title,
  onDeleteDraft,
}: IDraftJobCardProps) => {
  const navigate = useNavigate();

  const professionToDisplay = useJobProfessionDisplay({
    profession: professionType || ProfessionTypeEnum.RDH,
    subProfession,
  });

  const handleContinueClick = () => {
    navigate(`/permanent-jobs/postings/${id}/create`);
  };

  return (
    <JobListingCard
      data-cy="draft-job-card"
      status="draft"
      title={title || 'UNTITLED'}
      jobRole={professionType ? professionToDisplay || undefined : undefined}
      office={officeSelected ? office?.name || 'No Office Selected' : 'No Office Selected'}
      dateLabel={`Draft saved on ${moment(lastSavedAt).format('ddd, MMM D, YYYY')}`}
      onCardClick={handleContinueClick}
      menuButtonTestID="draft-job-card-menu"
      menuItems={[
        {
          label: 'Delete',
          testID: 'draft-job-card-delete',
          onSelect: () => onDeleteDraft?.(id),
        },
      ]}
    />
  );
};
